import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const PressReleases = lazy(() => import("@/pages/info/PressReleases"));

export const Route = createFileRoute("/pressreleaser/")({
  // Listan hämtas på servern så att pressreleaserna länkas i serverns HTML.
  loader: async ({ context }) => {
    const { scrapedPathListQueryOptions } = await import("@/hooks/useScrapedPage");
    const items = await context.queryClient.ensureQueryData(scrapedPathListQueryOptions("/pressreleaser")).catch(() => null);
    return { items };
  },
  head: () => seoHead("/pressreleaser"),
  component: PressRoute,
});

function PressRoute() {
  const { items } = Route.useLoaderData();
  return <PressReleases initialItems={items} />;
}
